import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

export default function Equipment() {
  const equipmentSwiper = new Swiper('.equipment-slider-2.no-padding-slider .equipment-slider-2__slider .swiper', {
    direction: 'horizontal',
    loop: false,
    spaceBetween: 20,
    slidesPerView: 1,
    draggable: true,
    preloadImages: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    scrollbar: {
      el: '.equipment-slider-2 .swiper-scrollbar',
      hide: false,
      draggable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.equipment-slider-2 .swiper-button-next',
      prevEl: '.equipment-slider-2 .swiper-button-prev',
    },
  });

  const slidersNextArrows = document.querySelectorAll('.equipment-slider-2.no-padding-slider .equipment-slider-2__slider .swiper-button-next');
  const slidersPrevArrows = document.querySelectorAll('.equipment-slider-2.no-padding-slider .equipment-slider-2__slider .swiper-button-prev');
  // Обработка нажатия на стрелку вперед
  slidersNextArrows.forEach((sliderNextArrows) => {
    sliderNextArrows.addEventListener('click', function nextArrowClick() {
      const thisSlider = this.closest('.swiper').swiper;
      // Указатель, определяющий в конце ли мы слайдера(определяется по классу sliderInEnd)
      const isEventOn = thisSlider.el.classList.contains('sliderInEnd');
      if (thisSlider.isBeginning) {
        thisSlider.el.classList.add('sliderInStart');
      } else {
        thisSlider.el.classList.remove('sliderInStart');
      }
      if (thisSlider.isEnd) {
        thisSlider.el.classList.add('sliderInEnd');
      } else {
        thisSlider.el.classList.remove('sliderInEnd');
      }
      if (thisSlider.isEnd && isEventOn) {
        thisSlider.slideTo(0);
        thisSlider.el.classList.add('sliderInStart');
      }
    });
  });
  slidersPrevArrows.forEach((sliderPrevArrows) => {
    sliderPrevArrows.closest('.swiper').classList.add('sliderInStart');
    sliderPrevArrows.addEventListener('click', function prevArrowClick() {
      const thisSlider = this.closest('.swiper').swiper;
      // Указатель, определяющий в начале ли мы слайдера(определяется по классу sliderInStart)
      const isEventOn = thisSlider.el.classList.contains('sliderInStart');
      if (thisSlider.isBeginning) {
        thisSlider.el.classList.add('sliderInStart');
      } else {
        thisSlider.el.classList.remove('sliderInStart');
      }
      if (thisSlider.isEnd) {
        thisSlider.el.classList.add('sliderInEnd');
      } else {
        thisSlider.el.classList.remove('sliderInEnd');
      }
      if (thisSlider.isBeginning && isEventOn) {
        thisSlider.slideTo(thisSlider.slides.length);
        thisSlider.el.classList.add('sliderInEnd');
      }
    });
  });
  // Обработка альтернативных способов изменения слайдера(Перетаскивания по нажатию на слайд или по движению скролбара)
  if (equipmentSwiper.length !== undefined) {
    equipmentSwiper.forEach((equipment) => {
      equipment.on('slideChange', function () {
        const thisSlider = this;
        thisSlider.el.classList.remove('sliderInEnd');
        thisSlider.el.classList.remove('sliderInStart');
      });
      equipment.on('reachEnd', function () {
        const thisSlider = this;
        thisSlider.el.classList.add('sliderInEnd');
      });
      equipment.on('reachBeginning', function () {
        const thisSlider = this;
        thisSlider.el.classList.add('sliderInStart');
      });
      // Переделать! Пересчитывание параметров слайдера при скрытии/появлении (нажатии на табы)
      equipment.on('resize', function () {
        this.scrollbar.updateSize();
      });
    });
  }
}
